import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';

import { useStoreState } from '~/store/hooks';
import Loader from '~/ui/components/common/Loader';
import EditCrisisAllocationForm from './EditCrisisAllocationForm';

import extractDateFromString from '~/utils/date/extractDateFromString';
import useGetEditClientAllocations from './hooks/useGetEditCrisisAllocations';
import { IParams } from './types';
import AllocationBreadcrumbs from './components/AllocationBreadcrumbs';

import styles from './EditCrisisAllocation.module.scss';

const EditCrisisAllocation = (): ReactElement => {
  const { actTeamId, clientAllocationDate } = useParams<IParams>();

  const { clinic: userClinic } = useStoreState(state => state.user.current);
  const clientAllocations = useStoreState(state => state.clientAllocation.current) || [];

  const { isLoading } = useGetEditClientAllocations({
    actTeamId,
    clientAllocationDate,
    isCrisis: true,
  });

  const currentAllocations = clientAllocations.filter(
    cAllocation => !cAllocation.isArchived && !!cAllocation.isCrisis,
  );

  if (isLoading) return <Loader />;

  return (
    <>
      <h2 className={styles.title}>{`Edit Crisis Allocation | ${extractDateFromString(
        currentAllocations?.[0]?.date || '',
      )}`}</h2>
      <AllocationBreadcrumbs />
      <EditCrisisAllocationForm
        clientAllocations={currentAllocations}
        actTeamId={actTeamId}
        clinicId={String(userClinic.id)}
      />
    </>
  );
};

export default EditCrisisAllocation;
